import OptimizelyStore from 'admin/stores/OptimizelyStore';

export const OptimizelyServiceModule = angular
    .module('app.components.optimizely.optimizelyService', [])
    .factory('optimizelyService', ($rootScope) => {
        function handleAsync(response) {
            $rootScope.$digest();
            return response;
        }

        return {
            getExperiments: () => OptimizelyStore.getExperiments().then(handleAsync),
            setUpExperiment: (experimentId, condition, variations, pageName) =>
                OptimizelyStore.setUpExperiment(experimentId, condition, variations, pageName),
            trackPage: pageName => OptimizelyStore.trackPage(pageName),
            trackEvent: eventName => OptimizelyStore.trackEvent(eventName)
        };
    }).name;


// WEBPACK FOOTER //
// ./src/app/services/data/optimizely.service.js